export default "/react/googleAdsIcon-c57eb2b9.svg";